import ReactDOM from "react-dom";
import React from "react";
import WidgetLoader from "../components/Widgets/WidgetLoader";
import ReactQuill from "react-quill-2";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import {makeid} from "./../../core/helpers/CoreHelpers";
import CONSTANTS from "./../helpers/Constants";
import Config from "./../../core/config/index";
import 'react-quill/dist/quill.snow.css';
import "react-datepicker/dist/react-datepicker.css";


export function widgetLoader(widgetList) {

    let widgetPrefix = makeid();
    for (let x in widgetList) {
        let w = widgetList[x];
        let widgetElementId = widgetPrefix + w.id;
        if (Config.dev()) {
            console.log("selector", w.selector);
        }
        if (w.selector) {
            let element = document.querySelector(w.selector);
            if (element) {
                let div = document.createElement('div');
                div.id = widgetElementId;
                // div.classList.add("widget-"+widgetType+"-"+x);
                let content = "";

                switch (w.injectionType) {
                    case CONSTANTS.INJECTION_TYPE.Prepend:
                        prepend(element, div);
                        break;
                    case CONSTANTS.INJECTION_TYPE.Append:
                        append(element, div);
                        break;
                    case CONSTANTS.INJECTION_TYPE.Before:
                        before(element, div);
                        break;
                    case CONSTANTS.INJECTION_TYPE.After:
                        after(element, div);
                        break;
                    case CONSTANTS.INJECTION_TYPE.Replace:
                        content = replace(element, div);
                        break;
                    default:
                        break;
                }
                if (document.getElementById(widgetElementId)) {
                    ReactDOM.render(
                        <WidgetLoader {...w} index={x} htmlElementContent={content}/>,
                        document.getElementById(widgetElementId)
                    );
                } else {
                    console.log("Could not inject, did not find element (" + widgetElementId + ")");
                }

            }
        }
    }
}

export function getFakeData() {
    return [
        {
            id: 1, //id of the witdhet
            title: "PREPEND", //title
            body: "-------", //body
            injectionType: "prepend", // how to inject element into html: prepend, append, before, after, replace
            selector: ".p-prerenderplaceholder", //css selector
            widgetType: "WidgetFaq" //widget component to be load, to beable to load different widgets
        },
        {
            id: 2,
            title: "APPEND",
            body: "---------",
            injectionType: "append",
            selector: ".p-prerenderplaceholder",
            widgetType: "WidgetTest"
        },
        {
            id: 3,
            title: "BEFORE",
            body: "------",
            injectionType: "before",
            selector: ".p-gridcol > .p-prerenderplaceholder",
            widgetType: "WidgetFaq"
        },
        {
            id: 4,
            title: "AFTER",
            body: "------",
            injectionType: "after",
            selector: ".p-prerenderplaceholder",
            widgetType: "WidgetFaq"
        },
        {
            id: 5,
            title: "REPLACE",
            body: "------",
            injectionType: "replace",
            selector: ".p-prerenderplaceholder",
            widgetType: "WidgetFaq"
        },
    ]
}

export function prepend(existingElement, newElement) {
    existingElement.insertBefore(newElement, existingElement.children[0]);
}

export function append(existingElement, newElement) {
    existingElement.insertBefore(newElement, existingElement.children[(existingElement.children.length)]);
}

export function before(existingElement, newElement) {
    existingElement.parentNode.insertBefore(newElement, existingElement);
}

export function after(existingElement, newElement) {
    existingElement.parentNode.insertBefore(newElement, existingElement.nextSibling);
}

export function replace(existingElement, newElement) {
    let content = existingElement.innerHTML;
    existingElement.innerHTML = newElement.outerHTML;
    return content;
}

export function getFormField(field) {

    switch (field.type) {
        case "datePicker":
            return (
                <DatePicker
                    name={field.name}
                    id={field.name}
                />
            );
        case "select":
            return (
                <Select
                    options={field.options}
                />
            );
        case "wysiwyg":
            return (
                <ReactQuill
                    name={field.name}
                />
            );
        default:
            if (Config.dev()) {
                console.log("Form Field", field);
            }
    }
    return (
        <input
            name={field.name}
            type="text"
            value=""
            id={field.name}
            className="sc-textboxWrapper"/>
    )
}


// WEBPACK FOOTER //
// ./src/widgets/helpers/widgetHelpers.js